<app-cms-footer
  class="attendee-cms-footer"
  [title]="title"
  [description]="description"
  [columns]="columns"
  [logo]="logo"
></app-cms-footer>
